import { IQueryConditionHandler } from './iquerycondition.handler';
import { QueryCondition, SingleNumberValue } from '@farris/component-querycondition';
import { CompareType } from '../enum/compare-type.enum';
import { ValueType } from '../enum/value-type.enum';
import { RelationType } from '../enum/relation-type.enum';

export class SingleNumberHandler implements IQueryConditionHandler {
  convert(qc: QueryCondition) {
    const dtv = (qc.value as SingleNumberValue);
    return [{
      'FilterField': qc.fieldCode,
      'Compare': (qc.compareType || qc.compareType === 0) ? qc.compareType : CompareType.Equal,
      'Value': dtv.numValue,
      'Relation': (qc.relation || qc.relation === 0) ? qc.relation : RelationType.And, // and undefined
      'Expresstype': ValueType.Value,
      'Lbracket': qc.Lbracket || null,
      'Rbracket': qc.Rbracket || null
    }];
  }
}
